import { AssetStep } from '@experiment-management-shared/types';
import api, { QueryConfig } from '@shared/api';
import { useQuery } from 'react-query';

type AudioStepsAPI = {
  steps: AssetStep[];
};

const getAudioSteps = async ({
  assetNames,
  experimentKeys
}: {
  assetNames: string[];
  experimentKeys: string[];
}) => {
  const { data } = await api.post<AudioStepsAPI>('asset/filter-steps', {
    assetNames,
    assetType: 'audio',
    experiments: experimentKeys
  });

  return data.steps || [];
};

type AudioPanelStepsQueryParams = {
  assetNames: string[];
  experimentKeys: string[];
};

export function useAudioPanelSteps(
  { assetNames, experimentKeys }: AudioPanelStepsQueryParams,
  config: QueryConfig<AssetStep[]>
) {
  const configEnabled = config?.enabled ?? true;
  const conditionsEnabled = !!assetNames?.length && !!experimentKeys?.length;

  return useQuery(
    [
      'audioPanelSteps',
      {
        assetNames: assetNames?.length ? assetNames.slice().sort() : assetNames,
        experimentKeys: experimentKeys.slice().sort()
      }
    ],
    () => getAudioSteps({ assetNames, experimentKeys }),
    { ...config, enabled: configEnabled && conditionsEnabled }
  );
}
